export const regularHeroIconTokens = [
  "arrowRight",
  "award",
  "check",
  "clock",
  "external",
  "google",
  "mapPin",
  "meta",
  "play",
  "shield",
  "sparkles",
  "star",
  "target",
  "users",
  "zap",
] as const;

export type RegularHeroIconToken = (typeof regularHeroIconTokens)[number];

export const regularHeroTokens = {
  colors: {
    lightBackground: "#f6fbf4",
    lightSurface: "rgba(255, 255, 255, 0.8)",
    lightText: "#10141d",
    lightTextSoft: "#273042",
    lightTextMuted: "#5a6475",
    lightBorder: "rgba(16, 20, 29, 0.12)",
    lightOverlay:
      "linear-gradient(90deg, rgba(248, 253, 246, 0.98) 0%, rgba(248, 253, 246, 0.92) 36%, rgba(248, 253, 246, 0.48) 58%, rgba(248, 253, 246, 0.08) 100%)",
    darkBackground: "#050508",
    darkSurface: "rgba(6, 6, 12, 0.72)",
    darkText: "#f7f7fb",
    darkTextSoft: "rgba(247, 247, 251, 0.82)",
    darkTextMuted: "rgba(247, 247, 251, 0.62)",
    darkBorder: "rgba(255, 255, 255, 0.16)",
    darkOverlay:
      "linear-gradient(90deg, rgba(1, 1, 5, 0.98) 0%, rgba(1, 1, 5, 0.9) 38%, rgba(1, 1, 5, 0.45) 63%, rgba(1, 1, 5, 0.08) 100%)",
    accent: "#37ad31",
    accentDark: "#258822",
    accentContrast: "#ffffff",
    highlight: "#37ad31",
    shadow: "0 24px 70px rgba(18, 25, 36, 0.14)",
  },
  radius: {
    shell: 8,
    media: 8,
    button: 8,
    trust: 8,
    pill: 999,
  },
  sizes: {
    maxWidth: 1536,
    minHeight: 760,
    mediaAspectRatio: "3 / 2",
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  defaults: {
    theme: "light",
    eyebrow: "Digital solutions that grow your business",
    title: "More Leads.\nMore Customers.",
    titleHighlight: "Real Growth.",
    lead:
      "We build fast websites, run smart marketing campaigns, and set up systems that turn visitors into loyal customers.",
    primaryAction: {
      label: "Grow Your Leads Now",
      href: "#contact",
      icon: false,
    },
    secondaryAction: {
      label: "Watch How It Works",
      href: "#video",
      icon: "play",
      iconPosition: "start",
      variant: "outline",
    },
    trustItems: [
      {
        icon: false,
        title: "5.0",
        text: "Based on 100+ reviews",
        stars: 5,
      },
      {
        icon: "google",
        title: "Google",
        text: "Partner",
      },
      {
        icon: "meta",
        title: "Meta",
        text: "Business Partner",
      },
    ],
  },
} as const;

export type RegularHeroColorToken = keyof typeof regularHeroTokens.colors;
